<common-confirm></common-confirm>

<div style="max-width: 600px; margin: 0 auto">
    <mat-card *ngFor="let mrb of mrbs" class="margin-bottom-10">
        <div class="flex row align-center">
            <div class="max">
                {{ mrb.name }}
            </div>

            <mat-slide-toggle
                    [checked]="allowed_mrbs.includes(mrb.slug)"
                    (change)="toggleMrb(mrb.slug, $event.checked)"
            ></mat-slide-toggle>
        </div>
    </mat-card>
</div>

<div class="padding-top-20"></div>

